const ScoreManager = () => import(/* webpackChunkName: "manager" */ './manage');
const ScoreTeacher = () => import(/* webpackChunkName: "manager" */ './scoreTeacher');
const ScoreSecretary = () => import(/* webpackChunkName: "manager" */ './scoreSecretary');
export default {
    routes: [
        {
            path: '/score/manager',
            name: 'ScoreManager',
            component: ScoreManager
        },
        {
            path: '/score/teacher',
            name: 'scoreTeacher',
            component: ScoreTeacher
        },
        {
            path: '/score/secretary',
            name: 'scoreSecretary',
            component: ScoreSecretary
        },
    ]
}